import { fg } from '@atlaskit/platform-feature-flags/fg';

import { TypeFilterValueKey } from '../../constants/filters/universal-type';
import {
	CODE_HOST_PRODUCT_KEYS,
	GITHUB_PRODUCT_KEYS,
	ProductKeys,
} from '../../constants/product-keys';

export const isCodeSearchEnabled = (): boolean => fg('rovo_t26_eu_code_search');

export const isLegacyCodeSearchEnabled = (): boolean =>
	!fg('rovo_t26_eu_code_search') && fg('rovo_github_code_search');

export const isAnyCodeSearchEnabled = (): boolean =>
	fg('rovo_t26_eu_code_search') || fg('rovo_github_code_search');

/**
 * Whether a search should ask the backend for code results. The entities payload and the
 * Relay `@include(if: $includeCodeSearch)` directive must both use this, or one will
 * request code the other cannot render.
 */
export const shouldRequestCodeResults = (
	selectedProducts: ProductKeys[],
	selectedTypes: readonly string[],
): boolean => {
	if (isCodeSearchEnabled()) {
		return (
			selectedProducts.some((product) => CODE_HOST_PRODUCT_KEYS.includes(product)) &&
			selectedTypes.includes(TypeFilterValueKey.Document)
		);
	}
	return (
		selectedProducts.length === 1 &&
		GITHUB_PRODUCT_KEYS.includes(selectedProducts[0]) &&
		isLegacyCodeSearchEnabled()
	);
};

/**
 * Maps a code result's `repository.scm` value ("github" or "bitbucket", from the
 * SearchResultCodeRepository schema) to its product key for icon and analytics attribution.
 */
export const scmToProductKey = (scm?: string | null): ProductKeys | undefined => {
	switch (scm) {
		case 'bitbucket':
			return ProductKeys.Bitbucket;
		case 'github':
			return ProductKeys.Github;
		default:
			return undefined;
	}
};
